import { CARGAR_ARTICULO, CARGAR_TRANSFERENCIA, CARGAR_INGRESOBODEGA, CARGAR_EGRESOBODEGA } from '../actions/inventario/actionTypes';
import { CARGAR_GASTOSIMPORTACION } from '../actions/importaciones/actionTypes';
import { CARGAR_CLIENTE } from '../actions/clientes/actionTypes';
import { INICIALIZAR_FORM } from '../actions/generales/actionTypes';
import { CARGAR_IMPORTACION } from '../actions/importaciones/actionTypes';
import { CARGAR_AJUSTE_PLAN_PAGO } from '../actions/importaciones/actionTypes';
import { CARGAR_COBRAZA } from '../actions/caja/actionTypes';
import { CARGAR_PROVEEDOR } from '../actions/compras/actionTypes';

const inicializacion_form = (state={data:{}}, action) => {
    switch(action.type){
        case INICIALIZAR_FORM:             
        case CARGAR_ARTICULO: 
        case CARGAR_CLIENTE: 
        case CARGAR_GASTOSIMPORTACION:
        case CARGAR_TRANSFERENCIA:    
        case CARGAR_INGRESOBODEGA:
        case CARGAR_EGRESOBODEGA:
        case CARGAR_IMPORTACION:
        case CARGAR_AJUSTE_PLAN_PAGO:
        case CARGAR_COBRAZA:
        case CARGAR_PROVEEDOR:
            return Object.assign({}, state, {data: action.data});                    
        default:
            return state;
    }
};

export default inicializacion_form;